export default __webpack_public_path__ + "static/media/CompanyDocExl.d0c3c966.xlsx";